module.exports = __webpack_public_path__ + "static/media/perfil.9402c554.svg";